/* eslint no-await-in-loop:0 */

const actions = {
    showCalendar() {
        const { showed, mobile } = this.main;

        if (showed) {
            return;
        }

        // Готовим календарь
        this.main.build();

        if (this.dateSelector) {
            const $header = this.dateSelector.buildHeader();

            this.main.setDateSelectorHeader($header);
            this.dateSelector.initObserver();
        }

        this.main.mount();
        this.main.show();
        this.sheet.build();

        this.main.toPosition();

        this.listener.setState('show');

        this.dispatch('presentView');

        this.input.$icon.addClass('focus');
        this.input.$element.addClass('focus');

        if (!mobile) {
            this.input.focus();
        }

        const config = this.config.get();
        const inputState = this.input.getState();

        // Проверяем нужно ли открыть селектор времени
        if (config.type === 'datetime') {
            const needShowSelectTime = inputState.parsed.date != null && inputState.parsed.month != null && inputState.parsed.year != null;

            if (needShowSelectTime) {
                this.dispatch('showTimeSelector');
            }
            else {
                this.dispatch('hideTimeSelector');
            }
        }

        if (mobile) {
            this.sLocker.setState('sheet-show');
        }
    },
    hideCalendar(force = false) {
        const { showed, mobile } = this.main;

        if (!showed) {
            return;
        }

        this.main.hide();

        if (!mobile) {
            this.input.blur();
        }

        this.input.$icon.removeClass('focus');
        this.input.$element.removeClass('focus');

        // Выпиливаем календарь из DOM
        setTimeout(() => {
            this.main.destroy();
        }, force ? 0 : mobile ? 700 : 150);

        this.input.checkError();

        this.dispatch('hideDateSelector');

        this.listener.setState('hide');

        this.sLocker.setState('sheet-hide');
    },

    selectDateByClick(selectedDate) {
        const { disabled } = selectedDate;

        if (disabled) {
            return;
        }

        const config = this.config.get();
        const { mobile } = this.main;
        const { parsed } = this.input.getState();
        const isSelectedDate = (
            (selectedDate.date === parsed.date) &&
            (selectedDate.month === parsed.month) &&
            (selectedDate.year === parsed.year)
        );

        // Не дергаемся раньше времени если ничего не изменилось
        if (!isSelectedDate) {
            this.input.setDate(selectedDate);
            this.sheet.setActiveDay();
        }

        setTimeout(() => {
            // Проверяем нужно ли скрыть календарь или открыть селектор времени
            // Закрываем календарь если есть такая опция или мобилка
            if (config.type === 'datetime') {
                this.dispatch('showTimeSelector');
            }
            else if (config.closeOnSelect || mobile) {
                this.dispatch('hideCalendar');
            }
        }, 80);
    },

    addYear(payload) {
        // this.listener.setState('sheet-freeze-on');
        this.sheet.addYear(payload);
        this.sheet.setActiveDay();
        // this.listener.setState('sheet-freeze-off');
    },

    resize() {
        this.main.checkMobile();
        this.main.toPosition();
        this.input.checkMobile();

        const { mobile } = this.main;

        if (mobile && this.main.showed) {
            this.sLocker.setState('sheet-show');
        }
        else {
            this.sLocker.setState('sheet-hide');
        }


        this.dispatch('presentView');
    },

    presentView() {
        const { showed } = this.main;

        if (!showed) {
            return;
        }

        const inputState = this.input.parse();

        // Если в input валидная дата, то отмечаем ее в sheet
        const parsedValid = inputState.valid && inputState.value.length;
        const initialDate = parsedValid ? inputState.parsed : this.helper.getCurrentDay();

        const $foundDay = this.sheet.findDay(initialDate);

        // Нет нужного нам дня в списке, добавляем весь год
        if (!$foundDay) {
            this.listener.setState('sheet-freeze-on');
            this.sheet.clear();

            this.dispatch('addYear', { year: initialDate.year - 1 });
            this.dispatch('addYear', { year: initialDate.year });
            this.dispatch('addYear', { year: initialDate.year + 1 });

            this.listener.setState('sheet-freeze-off');
        }

        // Подскроливаем до текущего месяца
        this.sheet.scroll.toDate(initialDate.month, initialDate.year);

        // Обновляем в шапке
        if (this.dateSelector) {
            this.dateSelector.setHeader(initialDate);
        }

        // Выбираем текущий день
        if (parsedValid) {
            this.sheet.setActiveDay();
        }
        else {
            this.sheet.clearActiveDay();
        }
    },

    showTimeSelector() {
        if (!this.timeSelector) {
            return false;
        }

        const inputValue = this.input.getState();

        this.timeSelector.build();
        this.timeSelector.show(inputValue);

        this.listener.setState('time-selector-show');
        this.sLocker.setState('time-selector-show');
    },

    hideTimeSelector() {
        if (!this.timeSelector) {
            return false;
        }

        this.timeSelector.hide();

        this.listener.setState('time-selector-hide');
        this.sLocker.setState('time-selector-hide');
    },

    selectTimeByClick({ hour, minute }) {
        if (this.timeSelector) {
            this.timeSelector.selectTime({ hour, minute });
        }

        this.input.setTime({ hour, minute });
        this.sheet.setActiveDay();

        // Закрываем тайм-селектор или календарь
        const config = this.config.get();
        const { mobile } = this.main;

        if (config.closeOnSelect || mobile) {
            this.dispatch('hideCalendar');
        }
        else {
            this.dispatch('hideTimeSelector');
        }
    },

    showDateSelector() {
        if (!this.dateSelector || this.dateSelector.showed) {
            return false;
        }

        const $date_selector = this.dateSelector.buildSelector();

        this.main.$container.append($date_selector);
        this.dateSelector.showSelector();

        this.dateSelector.highligthItems();
        this.dateSelector.scrollYearListToActive();

        setTimeout(() => {
            this.listener.setState('date-selector-show');
            this.sLocker.setState('date-selector-show');
        }, 100);
    },

    hideDateSelector() {
        if (!this.dateSelector || !this.dateSelector.showed) {
            return false;
        }

        this.dateSelector.hideSelector();

        this.listener.setState('date-selector-hide');
        this.sLocker.setState('date-selector-hide');
    },

    selectByDateSelector(payload) {
        const {
            month,
            year,
            direction
        } = payload;

        const checkLimits = (month, year) => {
            const {
                upperLimit,
                lowerLimit
            } = this.config.get();

            const upperLimitInvalid = (year === upperLimit.year) && (month > upperLimit.month);
            const lowerLimitInvalid = (year === lowerLimit.year) && (month < lowerLimit.month);

            return {
                month: upperLimitInvalid ? upperLimit.month : lowerLimitInvalid ? lowerLimit.month : month,
                year
            };
        };

        const presentsView = ({ month, year }) => {
            const includedYear = this.sheet.years.includes(year);

            if (!includedYear) {
                this.listener.setState('sheet-freeze-on');
                this.sheet.clear();

                this.dispatch('addYear', { year });

                this.listener.setState('sheet-freeze-off');
            }

            this.sheet.scroll.toDate(month, year);
            this.dateSelector.highligthItems({ month, year });
        };

        const checkSelectedStage = (direction) => {
            const needCloseDateSelector = this.dateSelector.setAndCheckSelectedStage(direction);

            if (needCloseDateSelector) {
                this.dispatch('hideDateSelector');
            }
        };

        const presentsDate = checkLimits(month, year);
        presentsView(presentsDate);
        checkSelectedStage(direction);
    }
};

export default function dispatch(action, payload) {
    if (!actions[action]) {
        console.warn(`DISPATCH - Unknown action "${ action }"`);
        return;
    }

    actions[action].call(this, payload);

    const { debug } = this.config.get();

    if (debug) {
        console.log('DISPATCH - ', action, payload, this);
    }
}
